/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 49:
/***/ (function() {

document.addEventListener('DOMContentLoaded', function () {
  var showMoreBtn = document.querySelector('[data-collection-selector="show-more-btn"]');
  if (!showMoreBtn) return;
  var shortDescription = document.querySelector('[data-collection-selector="short-description"]');
  var longDescription = document.querySelector('[data-collection-selector="long-description"]');
  var showMoreText = showMoreBtn.querySelector('[data-collection-selector="show-more"]');
  var showLessText = showMoreBtn.querySelector('[data-collection-selector="show-less"]');
  sanitizeDescription(shortDescription);
  sanitizeDescription(longDescription);
  showMoreBtn.addEventListener('click', function () {
    if (shortDescription.classList.contains('hidden')) {
      shortDescription.classList.remove('hidden');
      longDescription.classList.add('hidden');
      showMoreText.classList.remove('hidden');
      showLessText.classList.add('hidden');
      scrollToTop();
    } else {
      shortDescription.classList.add('hidden');
      longDescription.classList.remove('hidden');
      showMoreText.classList.add('hidden');
      showLessText.classList.remove('hidden');
    }
  });
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  function sanitizeDescription(descriptionContainer) {
    if (!descriptionContainer) return;
    descriptionContainer.removeAttribute('style');
    descriptionContainer.querySelectorAll('[style]').forEach(function (element) {
      element.removeAttribute('style');
    });
  }
});

/***/ }),

/***/ 995:
/***/ (function() {

function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
document.addEventListener("DOMContentLoaded", function () {
  initProductAsVariants();
});
function initProductAsVariants() {
  initVariantLinks();
  initVariantSelects();
}
function initVariantLinks() {
  document.querySelectorAll('[data-id="product-as-variant-link"]').forEach(function (el) {
    if (el.dataset.variantLinkInitialized === "true") {
      return;
    }
    el.dataset.variantLinkInitialized = "true";
    el.addEventListener("click", function (e) {
      e.preventDefault();
      switchProduct(this);
    });
  });
}
var variantSelectGlobalBound = false;
function initVariantSelects() {
  document.querySelectorAll("[data-variant-select]").forEach(function (select) {
    if (select.dataset.variantSelectInitialized === "true") {
      return;
    }
    var trigger = select.querySelector("[data-variant-select-trigger]");
    var menu = select.querySelector("[data-variant-select-menu]");
    var options = select.querySelectorAll("[data-variant-select-option]");
    if (!trigger || !menu) {
      return;
    }
    select.dataset.variantSelectInitialized = "true";
    trigger.addEventListener("click", function () {
      var isOpen = select.classList.contains("is-open");
      setSelectOpen(select, !isOpen);
    });
    options.forEach(function (option) {
      option.addEventListener("click", function (e) {
        e.preventDefault();
        var productLink = option.getAttribute("data-url");
        setSelectOpen(select, false);
        if (productLink) {
          changeProductSelection(productLink);
        }
      });
    });
  });
  if (!variantSelectGlobalBound) {
    variantSelectGlobalBound = true;
    document.addEventListener("click", handleVariantSelectOutsideClick);
    document.addEventListener("keydown", handleVariantSelectKeydown);
  }
}
function handleVariantSelectOutsideClick(event) {
  var select = event.target.closest("[data-variant-select]");
  if (select) {
    return;
  }
  document.querySelectorAll("[data-variant-select].is-open").forEach(function (openSelect) {
    setSelectOpen(openSelect, false);
  });
}
function handleVariantSelectKeydown(event) {
  if (event.key !== "Escape") {
    return;
  }
  document.querySelectorAll("[data-variant-select].is-open").forEach(function (openSelect) {
    setSelectOpen(openSelect, false);
  });
}
function setSelectOpen(select, isOpen) {
  var trigger = select.querySelector("[data-variant-select-trigger]");
  var menu = select.querySelector("[data-variant-select-menu]");
  select.classList.toggle("is-open", isOpen);
  if (menu) {
    menu.hidden = !isOpen;
  }
  if (trigger) {
    trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }
}
function changeProductSelection(_x) {
  return _changeProductSelection.apply(this, arguments);
}
function _changeProductSelection() {
  _changeProductSelection = _asyncToGenerator(_regenerator().m(function _callee(productLink) {
    var response, html, parser, doc, mainSelector, newMainContentElement, oldMainContentElement, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch(productLink);
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 2:
          _context.n = 3;
          return response.text();
        case 3:
          html = _context.v;
          parser = new DOMParser();
          doc = parser.parseFromString(html, "text/html");
          mainSelector = "main#main-content";
          newMainContentElement = doc.querySelector(mainSelector);
          oldMainContentElement = document.querySelector(mainSelector);
          if (!(!newMainContentElement || !oldMainContentElement)) {
            _context.n = 4;
            break;
          }
          throw new Error("Could not find main content element");
        case 4:
          oldMainContentElement.innerHTML = newMainContentElement.innerHTML;
          updateSEO(doc, productLink);
          window.history.pushState("", "", productLink);
          if (document.querySelector("#product-as-variants").dataset.scrollToTopOnVariantChange === "true") {
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          }
          initProductAsVariants();
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.error("Error loading product variant:", _t);
          debugger;
          setTimeout(function () {
            location.href = productLink;
          }, 1500);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _changeProductSelection.apply(this, arguments);
}
function updateSEO(doc, productLink) {
  var newTitle = doc.querySelector("title");
  if (newTitle) {
    document.title = newTitle.textContent;
  }
  var metaUpdates = [{
    selector: 'meta[name="description"]',
    attr: "content"
  }, {
    selector: 'meta[property="og:title"]',
    attr: "content"
  }, {
    selector: 'meta[property="og:description"]',
    attr: "content"
  }, {
    selector: 'meta[property="og:image"]',
    attr: "content"
  }, {
    selector: 'meta[property="og:url"]',
    attr: "content"
  }, {
    selector: 'meta[property="og:type"]',
    attr: "content"
  }, {
    selector: 'meta[name="twitter:title"]',
    attr: "content"
  }, {
    selector: 'meta[name="twitter:description"]',
    attr: "content"
  }, {
    selector: 'meta[name="twitter:image"]',
    attr: "content"
  }, {
    selector: 'link[rel="canonical"]',
    attr: "href"
  }];
  metaUpdates.forEach(function (_ref) {
    var selector = _ref.selector,
      attr = _ref.attr;
    var newMeta = doc.querySelector(selector);
    var currentMeta = document.querySelector(selector);
    if (newMeta && currentMeta) {
      currentMeta.setAttribute(attr, newMeta.getAttribute(attr));
    } else if (newMeta && !currentMeta) {
      document.head.appendChild(newMeta.cloneNode(true));
    }
  });
  var ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.setAttribute("content", productLink);
  }
}
function switchProduct(optionElement) {
  if (optionElement.getAttribute("aria-selected") !== "true") {
    var productLink = optionElement.getAttribute("href");
    changeProductSelection(productLink);
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _partials_collection_description__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var _partials_collection_description__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_partials_collection_description__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _partials_product_as_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(995);
/* harmony import */ var _partials_product_as_variants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_partials_product_as_variants__WEBPACK_IMPORTED_MODULE_1__);




}();
/******/ })()
;